"use client";
import { readAnalyticsConsent, readAnalyticsRuntime } from "./customy/analytics-client";
import { siteTagsMetric } from "./customy/tags-client";
import { analyticsPageType } from "./customy/analytics-contract";
import { canonicalPath } from "./i18n/routes";
import { webVitalProperties } from "./web-vitals";
import type { Metric } from "web-vitals";

let started = false;
export async function startWebVitals() {
  if (started || typeof window === "undefined" || navigator.webdriver || readAnalyticsConsent() !== "granted" || readAnalyticsRuntime() !== "enabled") return;
  started = true;
  try {
    const { onLCP, onINP, onCLS } = await import("web-vitals");
    const navigation = performance.getEntriesByType("navigation")[0];
    const path = navigation ? new URL(navigation.name).pathname : window.location.pathname;
    const pageType = analyticsPageType(canonicalPath(path));
    const report = (metric: Metric) => {
      if (readAnalyticsConsent() !== "granted" || readAnalyticsRuntime() !== "enabled") return;
      const properties = webVitalProperties(metric, pageType);
      if (properties) siteTagsMetric("web_vital", properties);
    };
    onLCP(report); onINP(report); onCLS(report);
  } catch { started = false; /* Measurement must never break navigation. */ }
}
